// extracted by mini-css-extract-plugin
export default {"footer":"T9_ePQ"};